import constants from 'common/helpers/constants'


const offerTestReasons = [
  'FINANCIAL_COMMITMENT', // "I don’t want to spend money on a subscription for luxury goods"
  'TOO_EXPENSIVE', // "$14.95 is too expensive, I would prefer to subscribe for Scentbird for $10/month"
  'FINANCIAL_VALUE', // "Scentbird’s fragrances are too small; it’s not a good value at $14.95"
]


/**
 * Check if user has access to 25% offer abc-test constants.abTests.unsubscribeOfferTest
 * only new subscribers (not resubscribed) with 2 months min and 7 months max of subscription duration
 * see SCNT-6121
 *
 * isOfferAlreadyApplied - don't show offers if user accepted it once
 *
 * @param {Object} subscription - state.models.subscription
 * @param {Object} isOfferAlreadyApplied - state.models.closedPopups.prolongOfferModal
 * @returns {Boolean}
 */
const checkIfUnsubscribeOfferTestAvailable = (subscription, isOfferAlreadyApplied) => {
  const { isResubscribed, subscriptionDate, nextBillingDate, isMonthlyPlan } = subscription

  const subDateMonth = new Date(subscriptionDate).getMonth()
  const billingDateMonth = new Date(nextBillingDate).getMonth()

  const subscriptionDuration = subDateMonth > billingDateMonth
    ? 12 + billingDateMonth - subDateMonth
    : billingDateMonth - subDateMonth

  const subscriptionDay = new Date(subscriptionDate).getDate()

  // nextBillingDate shifts to one month later in case of subscription after 21 day of the month
  const testDurationMin = subscriptionDay > 21 ? 2 : 1
  const testDurationMax = subscriptionDay > 21 ? 9 : 8

  const isSubscriptionDurationInTestRange = subscriptionDuration > testDurationMin && subscriptionDuration < testDurationMax

  return (
    isMonthlyPlan
    && !isResubscribed
    && isSubscriptionDurationInTestRange
    && !isOfferAlreadyApplied
  )
}


export {
  offerTestReasons,
  checkIfUnsubscribeOfferTestAvailable,
}
